import { render, staticRenderFns } from "./technicalReformDetail.vue?vue&type=template&id=70ea57d8&scoped=true"
import script from "./technicalReformDetail.vue?vue&type=script&lang=js"
export * from "./technicalReformDetail.vue?vue&type=script&lang=js"
import style0 from "./technicalReformDetail.vue?vue&type=style&index=0&id=70ea57d8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea57d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ea57d8')) {
      api.createRecord('70ea57d8', component.options)
    } else {
      api.reload('70ea57d8', component.options)
    }
    module.hot.accept("./technicalReformDetail.vue?vue&type=template&id=70ea57d8&scoped=true", function () {
      api.rerender('70ea57d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/facilityManage/technicalReformDetail.vue"
export default component.exports